<template>
    <v-navigation-drawer v-if="showBar" v-model="showBar" clipped fixed app>

        <v-list>

        <v-list-tile @click="routePush('/')">

            <v-list-tile-action>
                <v-icon>home</v-icon>
            </v-list-tile-action>

            <v-list-tile-title>Početna</v-list-tile-title>

        </v-list-tile>

        <v-list-tile @click="routePush('/costs')">

            <v-list-tile-action>
                <v-icon>attach_money</v-icon>
            </v-list-tile-action>

            <v-list-tile-title>Unos</v-list-tile-title>

        </v-list-tile>

        <v-list-group prepend-icon="perm_data_setting">


            <v-list-tile slot="activator">
                <v-list-tile-title>Korisnici</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="routePush('/users')">

                <v-list-tile-action>
                    <v-icon v-text="'account_box'"></v-icon>
                </v-list-tile-action>

                <v-list-tile-title v-text="'Članovi'"></v-list-tile-title>

            </v-list-tile>

            <v-list-tile @click="routePush('/families')">

                <v-list-tile-action>
                    <v-icon v-text="'accessibility_new'"></v-icon>
                </v-list-tile-action>

                <v-list-tile-title v-text="'Porodica'"></v-list-tile-title>

            </v-list-tile>


        </v-list-group>

    </v-list>

    <v-list>

        <v-list-group prepend-icon="scatter_plot">


            <v-list-tile slot="activator">
                <v-list-tile-title>Grupa</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="routePush('/properties')">

                <v-list-tile-action>
                    <v-icon v-text="'scatter_plot'"></v-icon>
                </v-list-tile-action>

                <v-list-tile-title v-text="'Grupa'"></v-list-tile-title>

            </v-list-tile>

            <v-list-tile @click="routePush('/attributes')">

                <v-list-tile-action>
                    <v-icon v-text="'timeline'"></v-icon>
                </v-list-tile-action>

                <v-list-tile-title v-text="'Pod grupa'"></v-list-tile-title>

            </v-list-tile>


        </v-list-group>

    </v-list>

    </v-navigation-drawer>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        props: ['drawer'],
        computed: {
            showBar: {
                get() {
                    return this.drawer;
                },
                set() {

                },
            },
            ability(){
                return this.$store.getters['ability/getPermissionList'];
            },
            user(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            routePush(route){
                this.$router.push(route);
            },
            checkGuard(name){
                let res = false;
                let permissionList = this.$store.getters['ability/getPermissionList'];
                permissionList.forEach(permission => {
                    if(name === permission.name){
                        res = true;
                    }
                });
                return res;
            },
        },
    }
</script>
